// ⚠️ Auto-generated. Run `npm run gdi` to regenerate.

import { LanguageOptions, ServiceType, ServiceData } from '@/types';

import { ASTROLOGY_DATA_BA } from './astrology/BA';
import { ASTROLOGY_DATA_BG } from './astrology/BG';
import { ASTROLOGY_DATA_DE } from './astrology/DE';
import { ASTROLOGY_DATA_EE } from './astrology/EE';
import { ASTROLOGY_DATA_EN } from './astrology/EN';
import { ASTROLOGY_DATA_FI } from './astrology/FI';
import { ASTROLOGY_DATA_FR } from './astrology/FR';
import { ASTROLOGY_DATA_HR } from './astrology/HR';
import { ASTROLOGY_DATA_LT } from './astrology/LT';
import { ASTROLOGY_DATA_LV } from './astrology/LV';
import { ASTROLOGY_DATA_NO } from './astrology/NO';
import { ASTROLOGY_DATA_PL } from './astrology/PL';
import { ASTROLOGY_DATA_RO } from './astrology/RO';
import { ASTROLOGY_DATA_RS } from './astrology/RS';
import { ASTROLOGY_DATA_SK } from './astrology/SK';
import { COOKING_DATA_BG } from './cooking/BG';
import { COOKING_DATA_CZ } from './cooking/CZ';
import { COOKING_DATA_DE } from './cooking/DE';
import { COOKING_DATA_DK } from './cooking/DK';
import { COOKING_DATA_EE } from './cooking/EE';
import { COOKING_DATA_EN } from './cooking/EN';
import { COOKING_DATA_FI } from './cooking/FI';
import { COOKING_DATA_FR } from './cooking/FR';
import { COOKING_DATA_HR } from './cooking/HR';
import { COOKING_DATA_LT } from './cooking/LT';
import { COOKING_DATA_LV } from './cooking/LV';
import { COOKING_DATA_NO } from './cooking/NO';
import { COOKING_DATA_PL } from './cooking/PL';
import { COOKING_DATA_RO } from './cooking/RO';
import { COOKING_DATA_RS } from './cooking/RS';
import { COOKING_DATA_SE } from './cooking/SE';
import { COOKING_DATA_SI } from './cooking/SI';
import { COOKING_DATA_SK } from './cooking/SK';
import { FITNESS_DATA_BA } from './fitness/BA';
import { FITNESS_DATA_BG } from './fitness/BG';
import { FITNESS_DATA_CZ } from './fitness/CZ';
import { FITNESS_DATA_DE } from './fitness/DE';
import { FITNESS_DATA_DK } from './fitness/DK';
import { FITNESS_DATA_EE } from './fitness/EE';
import { FITNESS_DATA_EN } from './fitness/EN';
import { FITNESS_DATA_FI } from './fitness/FI';
import { FITNESS_DATA_FR } from './fitness/FR';
import { FITNESS_DATA_HR } from './fitness/HR';
import { FITNESS_DATA_LT } from './fitness/LT';
import { FITNESS_DATA_LV } from './fitness/LV';
import { FITNESS_DATA_NO } from './fitness/NO';
import { FITNESS_DATA_PL } from './fitness/PL';
import { FITNESS_DATA_RO } from './fitness/RO';
import { FITNESS_DATA_RS } from './fitness/RS';
import { FITNESS_DATA_SE } from './fitness/SE';
import { FITNESS_DATA_SI } from './fitness/SI';
import { FITNESS_DATA_SK } from './fitness/SK';
import { LOVE_DATA_BA } from './love/BA';
import { LOVE_DATA_BG } from './love/BG';
import { LOVE_DATA_DE } from './love/DE';
import { LOVE_DATA_EE } from './love/EE';
import { LOVE_DATA_EN } from './love/EN';
import { LOVE_DATA_FI } from './love/FI';
import { LOVE_DATA_FR } from './love/FR';
import { LOVE_DATA_LT } from './love/LT';
import { LOVE_DATA_LV } from './love/LV';
import { LOVE_DATA_NO } from './love/NO';
import { LOVE_DATA_PL } from './love/PL';
import { LOVE_DATA_RO } from './love/RO';
import { LOVE_DATA_RS } from './love/RS';
import { LOVE_DATA_SK } from './love/SK';
import { MEDITATION_DATA_BG } from './meditation/BG';
import { MEDITATION_DATA_DE } from './meditation/DE';
import { MEDITATION_DATA_EE } from './meditation/EE';
import { MEDITATION_DATA_EN } from './meditation/EN';
import { MEDITATION_DATA_FI } from './meditation/FI';
import { MEDITATION_DATA_FR } from './meditation/FR';
import { MEDITATION_DATA_LT } from './meditation/LT';
import { MEDITATION_DATA_LV } from './meditation/LV';
import { MEDITATION_DATA_NO } from './meditation/NO';
import { MEDITATION_DATA_PL } from './meditation/PL';
import { MEDITATION_DATA_RO } from './meditation/RO';
import { MEDITATION_DATA_RS } from './meditation/RS';
import { MEDITATION_DATA_SK } from './meditation/SK';
import { PILATES_DATA_BA } from './pilates/BA';
import { PILATES_DATA_BG } from './pilates/BG';
import { PILATES_DATA_CZ } from './pilates/CZ';
import { PILATES_DATA_DE } from './pilates/DE';
import { PILATES_DATA_DK } from './pilates/DK';
import { PILATES_DATA_EE } from './pilates/EE';
import { PILATES_DATA_EN } from './pilates/EN';
import { PILATES_DATA_FI } from './pilates/FI';
import { PILATES_DATA_FR } from './pilates/FR';
import { PILATES_DATA_HR } from './pilates/HR';
import { PILATES_DATA_LT } from './pilates/LT';
import { PILATES_DATA_LV } from './pilates/LV';
import { PILATES_DATA_NO } from './pilates/NO';
import { PILATES_DATA_PL } from './pilates/PL';
import { PILATES_DATA_RO } from './pilates/RO';
import { PILATES_DATA_RS } from './pilates/RS';
import { PILATES_DATA_SE } from './pilates/SE';
import { PILATES_DATA_SI } from './pilates/SI';
import { PILATES_DATA_SK } from './pilates/SK';
import { YOGA_DATA_BA } from './yoga/BA';
import { YOGA_DATA_BG } from './yoga/BG';
import { YOGA_DATA_CZ } from './yoga/CZ';
import { YOGA_DATA_DE } from './yoga/DE';
import { YOGA_DATA_DK } from './yoga/DK';
import { YOGA_DATA_EE } from './yoga/EE';
import { YOGA_DATA_EN } from './yoga/EN';
import { YOGA_DATA_FI } from './yoga/FI';
import { YOGA_DATA_FR } from './yoga/FR';
import { YOGA_DATA_HR } from './yoga/HR';
import { YOGA_DATA_LT } from './yoga/LT';
import { YOGA_DATA_LV } from './yoga/LV';
import { YOGA_DATA_NO } from './yoga/NO';
import { YOGA_DATA_PL } from './yoga/PL';
import { YOGA_DATA_RO } from './yoga/RO';
import { YOGA_DATA_RS } from './yoga/RS';
import { YOGA_DATA_SE } from './yoga/SE';
import { YOGA_DATA_SI } from './yoga/SI';
import { YOGA_DATA_SK } from './yoga/SK';

const DATA: ServiceDataMap = {
  astrology: {
    BA: ASTROLOGY_DATA_BA,
    BG: ASTROLOGY_DATA_BG,
    DE: ASTROLOGY_DATA_DE,
    EE: ASTROLOGY_DATA_EE,
    EN: ASTROLOGY_DATA_EN,
    FI: ASTROLOGY_DATA_FI,
    FR: ASTROLOGY_DATA_FR,
    HR: ASTROLOGY_DATA_HR,
    LT: ASTROLOGY_DATA_LT,
    LV: ASTROLOGY_DATA_LV,
    NO: ASTROLOGY_DATA_NO,
    PL: ASTROLOGY_DATA_PL,
    RO: ASTROLOGY_DATA_RO,
    RS: ASTROLOGY_DATA_RS,
    SK: ASTROLOGY_DATA_SK,
  },
  cooking: {
    BG: COOKING_DATA_BG,
    CZ: COOKING_DATA_CZ,
    DE: COOKING_DATA_DE,
    DK: COOKING_DATA_DK,
    EE: COOKING_DATA_EE,
    EN: COOKING_DATA_EN,
    FI: COOKING_DATA_FI,
    FR: COOKING_DATA_FR,
    HR: COOKING_DATA_HR,
    LT: COOKING_DATA_LT,
    LV: COOKING_DATA_LV,
    NO: COOKING_DATA_NO,
    PL: COOKING_DATA_PL,
    RO: COOKING_DATA_RO,
    RS: COOKING_DATA_RS,
    SE: COOKING_DATA_SE,
    SI: COOKING_DATA_SI,
    SK: COOKING_DATA_SK,
  },
  fitness: {
    BA: FITNESS_DATA_BA,
    BG: FITNESS_DATA_BG,
    CZ: FITNESS_DATA_CZ,
    DE: FITNESS_DATA_DE,
    DK: FITNESS_DATA_DK,
    EE: FITNESS_DATA_EE,
    EN: FITNESS_DATA_EN,
    FI: FITNESS_DATA_FI,
    FR: FITNESS_DATA_FR,
    HR: FITNESS_DATA_HR,
    LT: FITNESS_DATA_LT,
    LV: FITNESS_DATA_LV,
    NO: FITNESS_DATA_NO,
    PL: FITNESS_DATA_PL,
    RO: FITNESS_DATA_RO,
    RS: FITNESS_DATA_RS,
    SE: FITNESS_DATA_SE,
    SI: FITNESS_DATA_SI,
    SK: FITNESS_DATA_SK,
  },
  love: {
    BA: LOVE_DATA_BA,
    BG: LOVE_DATA_BG,
    DE: LOVE_DATA_DE,
    EE: LOVE_DATA_EE,
    EN: LOVE_DATA_EN,
    FI: LOVE_DATA_FI,
    FR: LOVE_DATA_FR,
    LT: LOVE_DATA_LT,
    LV: LOVE_DATA_LV,
    NO: LOVE_DATA_NO,
    PL: LOVE_DATA_PL,
    RO: LOVE_DATA_RO,
    RS: LOVE_DATA_RS,
    SK: LOVE_DATA_SK,
  },
  meditation: {
    BG: MEDITATION_DATA_BG,
    DE: MEDITATION_DATA_DE,
    EE: MEDITATION_DATA_EE,
    EN: MEDITATION_DATA_EN,
    FI: MEDITATION_DATA_FI,
    FR: MEDITATION_DATA_FR,
    LT: MEDITATION_DATA_LT,
    LV: MEDITATION_DATA_LV,
    NO: MEDITATION_DATA_NO,
    PL: MEDITATION_DATA_PL,
    RO: MEDITATION_DATA_RO,
    RS: MEDITATION_DATA_RS,
    SK: MEDITATION_DATA_SK,
  },
  pilates: {
    BA: PILATES_DATA_BA,
    BG: PILATES_DATA_BG,
    CZ: PILATES_DATA_CZ,
    DE: PILATES_DATA_DE,
    DK: PILATES_DATA_DK,
    EE: PILATES_DATA_EE,
    EN: PILATES_DATA_EN,
    FI: PILATES_DATA_FI,
    FR: PILATES_DATA_FR,
    HR: PILATES_DATA_HR,
    LT: PILATES_DATA_LT,
    LV: PILATES_DATA_LV,
    NO: PILATES_DATA_NO,
    PL: PILATES_DATA_PL,
    RO: PILATES_DATA_RO,
    RS: PILATES_DATA_RS,
    SE: PILATES_DATA_SE,
    SI: PILATES_DATA_SI,
    SK: PILATES_DATA_SK,
  },
  yoga: {
    BA: YOGA_DATA_BA,
    BG: YOGA_DATA_BG,
    CZ: YOGA_DATA_CZ,
    DE: YOGA_DATA_DE,
    DK: YOGA_DATA_DK,
    EE: YOGA_DATA_EE,
    EN: YOGA_DATA_EN,
    FI: YOGA_DATA_FI,
    FR: YOGA_DATA_FR,
    HR: YOGA_DATA_HR,
    LT: YOGA_DATA_LT,
    LV: YOGA_DATA_LV,
    NO: YOGA_DATA_NO,
    PL: YOGA_DATA_PL,
    RO: YOGA_DATA_RO,
    RS: YOGA_DATA_RS,
    SE: YOGA_DATA_SE,
    SI: YOGA_DATA_SI,
    SK: YOGA_DATA_SK,
  },
} as const;

type ServiceDataMap = {
  [service in ServiceType]: Partial<Record<LanguageOptions, ServiceData>>;
};

export default DATA;
